import type { ReactNode } from "react";
import { ScrollArea } from "@/shared/ui/scroll-area";
import { cn } from "@/shared/lib/utils";

/** Классы `DialogContent` для модалок доски: шапка и подвал на месте, скроллится только тело. */
export const BOARD_DIALOG_CLASS = "gap-0 overflow-hidden p-0 sm:max-w-[640px]";
export const BOARD_DIALOG_HEADER = "px-6 pt-6 pb-4";

/** Тело модалки в скролле нашего UI (а не браузерном): растёт по содержимому до высоты экрана за вычетом шапки/подвала. */
export function DialogBody({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <ScrollArea className="[&>[data-slot=scroll-area-viewport]]:max-h-[calc(90dvh-9rem)]">
      <div className={cn("flex flex-col gap-4 px-6 pb-6", className)}>{children}</div>
    </ScrollArea>
  );
}
